import { useEffect, useState } from "react";


export function useDeviceWidth() {
    const [windowScreen, setWindowScreen] = useState(window.screen.width); 

    useEffect(() => {
        const handleUpdateScreenWidth = () => {
          setWindowScreen(window.screen.width)
        }
    
        window.addEventListener('resize', handleUpdateScreenWidth);
    
        return () => {
          window.removeEventListener('resize', handleUpdateScreenWidth);
        };
      }, [])

    return { windowScreen };
}

 